import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from 'react';
import '../../styles/game/GameLimits.css';
import '../../styles/game/howToPlay.css';



function GameLimits({ isOpen, onClose, GameLimitsOpen }) {
    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();
    useEffect(() => {
        if (isOpen) {
            setTimeout(() => setIsVisible(true), 10);
        } else {
            setIsVisible(false);
        }
    }, [isOpen]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    return (
        <>
            <div className={`modalWrapper ${isVisible ? "show" : "fade-out"}`}
                 onClick={() => {
                     setTimeout(() => setIsVisible(false), 10);
                     onClose();
                 }}>
            </div>
            <div className={`gameRulesModal ${isVisible ? "show" : "fade-out"}`} onClick={() => {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }}>
                <div className={`gameLimitsWrapper ${isVisible ? "show" : "fade"}`}>
                    <div className={'gameRulesContent'} onClick={(e) => e.stopPropagation()}>
                        <div className={'gameRulesHeader'}>
                            <span>{t("gameLimits").toUpperCase()}</span>
                            <button className={'gameRulesCloseBtn'} onClick={() => {
                                setTimeout(() => setIsVisible(false), 10);
                                onClose();
                            }}>
                                <span>×</span>
                            </button>
                        </div>
                        <div className={'gameLimitsBody'}>
                            <ul className={'gameLimitsListGroup'}>
                                <li className={'gl-list-item gl-list-item-border-top'}>
                                    <div className={'gl-list-item-text'}>
                                        <span>{t("minimumBetUsd")}</span>
                                        <span>USD:</span>
                                    </div>
                                    <span className={'badge'}>
                                        0.10
                                    </span>
                                </li>
                                <li className={'gl-list-item'}>
                                    <div className={'gl-list-item-text'}>
                                        <span>{t("maximumBetUsd")}</span>
                                        <span>USD:</span>
                                    </div>
                                    <span className={'badge'}>
                                        300.00
                                    </span>
                                </li>
                                <li className={'gl-list-item gl-list-item-border-bottom'}>
                                    <div className={'gl-list-item-text'}>
                                        <span>{t("maximumWin")}</span>
                                        <span>USD:</span>
                                    </div>
                                    <span className={'badge'}>
                                        30,000.00
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GameLimits;